import CooperativesList from "./CooperativesList";

export default CooperativesList;
